import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Container from '@mui/material/Container'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useTranslation } from 'react-i18next'

export default function Contact ({ race }) {
  const { t } = useTranslation('race')
  return (
    <Container maxWidth='xl'>
      <Typography
        variant='h5' gutterBottom sx={{
        fontWeight: 'bold'
      }}
      >
        {t('contact.title')}
      </Typography>
      <Typography variant='body1' paragraph>
        {t('contact.intro')}
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography>
          {t('contact.emailLabel')} <Link href='mailto:info@peakssports.com' target='_blank'>info@peakssports.com</Link>
        </Typography>
      </Box>
      <Button
        variant='outlined'
        color='primary'
        startIcon={<WhatsAppIcon />}
        sx={{ my: 3, color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
        onClick={() => window.open('https://wa.me/971506660724', '_blank')}
      >
        {t('contact.chatWhatsApp')}
      </Button>

      {(race.googleMaps || race.waze) &&
        <>
          <Divider sx={{ my: 3 }} />
          <Typography
            variant='h5' gutterBottom sx={{
            fontWeight: 'bold'
          }}
          >
            {t('contact.locationTitle')}
          </Typography>
          <Typography variant='body1' paragraph>
            {t('contact.locationIntro')}
          </Typography>

          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            {race.googleMaps && (
            <IconButton
              component={Link}
              href={race.googleMaps}
              target='_blank'
              rel='noopener noreferrer'
              sx={{ p: 1 }}
              aria-label={t('contact.navigateGoogleMaps')}
            >
              <img src='https://d1hi0tbu2kom2c.cloudfront.net/assets/google.png' alt='Google Maps' width='64' height='64' style={{ borderRadius: 8 }} />
            </IconButton>
            )}
            {race.waze && (
            <IconButton
              component={Link}
              href={race.waze}
              target='_blank'
              rel='noopener noreferrer'
              sx={{ p: 1, ml: 2 }}
              aria-label={t('contact.navigateWaze')}
            >
              <img src='https://d1hi0tbu2kom2c.cloudfront.net/assets/waze.png' alt='Waze' width='64' height='64' />
            </IconButton>
            )}
          </Box>
        </>}

      <Divider sx={{ my: 3 }} />

      <Typography
        variant='h5' gutterBottom sx={{
        fontWeight: 'bold'
      }}
      >
        {t('contact.duringEvent')}
      </Typography>
      {race?.emergencyContacts?.length &&
        <>
          <Typography variant='h6' paragraph>
            {t('contact.emergencyOrganizers')}
          </Typography>
          {race?.emergencyContacts?.map((contact, i) => (
            <Typography key={i} sx={{ mb: 2 }}>
              {t('contact.mobileLabel')} <Link href={`tel:+${contact.trim()}`} target='_blank'>00{contact}</Link>
            </Typography>
          ))}
        </>}
      <Typography variant='h6' paragraph>
        {t('contact.uaeEmergency')}
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <Link href='tel:999' target='_blank'>{t('contact.police')}</Link>
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <Link href='tel:998' target='_blank'>{t('contact.ambulance')}</Link>
      </Typography>
      <Typography sx={{ mb: 2 }}>
        <Link href='tel:997' target='_blank'>{t('contact.fire')}</Link>
      </Typography>

      {/* info@peakssports.com
      whatsapp organizer
      insta
      Whatsapp races group

      Peaks Sports is a registered trademark, incorporated in Dubai

      Social page:

      Join us on trail for weekend community runs. */}
    </Container>
  )
}
